export const API_URL = {
    GETWAY_URL: process.env.REACT_APP_GETWAY_API,
    GETWAY_API: process.env.REACT_APP_GETWAY_API + 'insurancebox/',
    GETWAY_DOCS_API: process.env.REACT_APP_GETWAY_API + 'insurancebox-docs/',
};

export const APIV = 1;
export const apikey = `insurancebox-ac1faa7b-9fe9-4483-9525-5cc4ce94c639`;
export const CURRENCY_SYMBOL = 'Rp';
export const DOC_UPLOAD_VALIDATION = { "minSize": 25000, "maxSize": 5000000 }

export const FIELD_TYPE = {
    TEXT_BOX: 'tb',
    DROP_DOWN: 'dd',
    DROPDOWN_INPUT_FIELD: 'ddtb',
    SEARCHABLE_DROP_DOWN: 'sdd',
    READ_ONLY_TEXT_BOX: 'ro',
    DATE_PICKER: 'date',
    MOBILE_FIELD: 'mobile',
    STICKY_FIELD: "sticky",
    EMAIL: 'email',
    MARKET_MRP: 'market_mrp',
    CITY: 'city',
    STATE: 'state',
    LOCALITY: 'locality',
    RADIO_BOX: 'radio',
    MRP_UPPING: 'mrp_upping',
    CURRENCY: 'currency',
    FUTURE_DATE: 'future_date',
    TELEPHONE: 'telephone',
    CHECK_BOX: 'checkbox',
    SELECT_ADDON: 'select_addon',
    SUM: 'sum',
    TEXT_AREA: 'ta',
    MULTI_DROP_DOWN: 'mdd',
    INFO: 'static_info',
    MMV: 'mmv',
    DATE_TIME: 'date_time',
    TITLE:'title',
    SWITCH:'switch',
    LABEL: 'label',
    MUTLI_RADIO_BOX: 'multiple_radio'
}


export const ADD_ONS_TYPE = {
    BODILY_INJURY: 'bi',
    PROPERTY_DAMAGE: 'pd',
    PERSONAL_ACCIDENT: 'pa',
    RIOTS_STRIKES_CIVIL: 'rsc',
    TOWING_ROWDSIDE: 'tra',
    ACTS_OF_NATURE: 'an'
} 

export const REGEX_DECIMAL_VALIDATION = /^[0-9]*(\.[0-9]{0,2})?$/;

export const REDIRECT_URLS: any = {
	"beta" : "https://stage-sso.oto.com/google?redirect=",
	"preprod" : "https://stage-sso.oto.com/google?redirect=",
	"prod" : "https://sso.oto.com/google?redirect=",
	"local" : "https://stage-sso.oto.com/google?redirect="
}
let reactAppEnv: any = process.env.REACT_APP_ENV;
export const AGENT_WEB = 6;

export const REDIRECT_URL: any = REDIRECT_URLS[reactAppEnv]

export const INS_TYPE_COMPREHENSIVE = 1;
export const INS_TYPE_CTPL          = 2;
export const STATUS_TYPE = [{value:"submitted",label:"Submitted",key:"1"},{value:"policy_issued",label:"Issued",key:"2"},{value:"pending_payment",label:"Pending Payment",key:"3"},{value:"pending",label:"Pending Application",key:"4"}]

export const LEAD_LIST_HEADER_COLUMN:any= {"submitted":["Customer Name","Vehicle Details","Created On"],"policy_issued":["Customer Name","Vehicle Name","Plate No","Issue Date","Action"],"pending_payment":["Customer Name","Vehicle Name","Pending Payment","Due Date","Status"],"pending":["Customer Name","Vehicle Name","Created On"],"claim":["Customer Name","Vehicle Details","Policy No","Policy Expiry Date","Claim Status","Action"]}

export const LEAD_LIST_FILTER = {
    taskSummaryFilters: [
      { value: 'all', label: 'Till Today (All)' },
      { value: 'mtd', label: 'MTD' },
      { value: 'cdr', label: 'Custom Date Range' },
    ],
    pendingPaymentFilters: [
      { value: 'nd', label: 'Next 7 Days' },
      { value: 'nm', label: 'Next Month' },
      { value: 'all', label: 'Till Today (All)' },
      { value: 'mdd', label: 'Missed Due Date' },
      { value: 'cdr', label: 'Custom Date Range' },
    ],
    raised_soa : [
      { value: '1', label: 'Yes' },
      { value: '0', label: 'No' }
    ]
};


export const REGEX_DECIMAL_VALIDATION_8 = /^[0-9]*(\.[0-9]{0,8})?$/;


export const WITH_RULE_ENGINE = 1
export const WITHOUT_RULE_ENGINE = 2


export const DOCUMENT_CATEGORY: any = {
    "orcr": 1, "existing_policy": 3, "vehicle_photos": 2,"others":27
}

export const REGEX_EMAIL_VALIDATION = /^[^@]+@[^@]+\.[^@.]{2,15}$/;

export const APP_TYPE_AGENCY = 4;

export const CLAIM_TYPE_CREATED_SOURCE = {claimBox: 1, agentWeb: 2, agentApp: 3}
export const EFFECTIVITY_EXPIRY_INTERVAL = 60;

export const STATUS_CODES = {"success": 200, "failure": 400, 'unauthorized': 401, 'unavailable': 503}

export const SCREEN_SIZE = 768

export const REGEX_NUMBER_WITH_TWO_DECIMAL = /^[0-9]+(\.[0-9]{0,2})?$/;
export const DEFAULT_PAGE_NO = 1;
export const DEFAULT_PAGINATION_COUNT = 10;
export const DEFAULT_INPUTFIELD_LENGTH = 1000;
export const MAX_FILE_UPLOAD = 5;
export const MAX_OTP_TIMER = 59;
export const REGEX_EMAIL = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i; // eslint-disable-line
export const REGEX_MOBILE = /^[8]\d{0,11}$/;
export const REGEX_CAMEL_CASE = /(?:^\w|[A-Z]|\b\w)/g;

export const BIKE_INS_VEHICLE_TYPE_ID = 11;
export const COMMERCIAL_BIKE_INS_VEHICLE_TYPE_ID = 12;

export const API_VERSION_V2 = 'v2';
export const DOC_COLOR_CODE = {
  OTHER:"#D8EAFF",
  VEHICLE:"#FFF1D6",
  OCR:"#BFF8FC"
}

export const COUNTRY_CODE = process.env.REACT_APP_COUNTRY_CODE
export const LEAD_LIST_HEADER_COLUMN_ID:any= {"quotation_shared":["Customer Name","Vehicle Details","Insurer","Insurance ID","shared on","Status","Action"],"submitted":["Customer Name","Vehicle Details","Insurer","Insurance ID","shared on","Status","Action"],"policy_issued":["Customer Name","Vehicle Details","Insurer","Insurance ID","shared on","Status","Action"]}
export const STATUS_TYPE_ID = [{value:"quotation_shared",label:"Quotation Shared",key:"1"},{value:"submitted",label:"On Process",key:"2"},{value:"policy_issued",label:"Issued",key:"3"}]
export const COMMISSION_MAIN_TAB:Record<string,any>={
  "actual_earning":1,
  "potential_payment_tab":2
}
export const COMMISSION_SUB_TAB:Record<string,any>={
  "commission":"c",
  "points":"p"
}
export const COMMISSION_MAIN_TAB_KEY:Record<string,any>={
  ACTAUL_EARNING:'actual_earning',
  POTENTIAL_PAYMENT:'potential_payment_tab'
}
export const COMMISSION_SUB_TAB_KEY:Record<string,any>={
  ALL:'all',
  POINTS:'points',
  COMMISSION:'commision'
}
export const FILTER_TYPE ={
  EARNING_DETAILS:"Earning Details"
}

export const MAX_PAYMENT_FILE_UPLOAD = 2;
export const WHATSAPP_WEB_URL = "https://web.whatsapp.com/send?text=";
export const API_SOURCE={
  AGENT_WEB:'agent_app'
}
export const GATEWAY_APIS=['/notification/fcm/unread_count_history','/notification/fcm/get_notification_history','/notification/fcm/read_notification_history','/core/commonservice/docs_upload']
export const DASHBOAED_TILES={
  POTENTIAL_EARNING:'Potential Earning',
  PAID_EARNING:'Paid Earning',
  AGENT_COMMISSION:'Agent Commission Change'
}

export const CURRENCY_CODE = 'id-ID';
export const LOGIN_TYPE = ['agency','sales_user']

export const CHANGE_PASSWORD_STEP = {
    EMAIL: 1,
    VERIFY_OTP: 2,
    NEW_PASSWORD: 3,
}
export const OTP_INDEXES = [0, 1, 2, 3];
export const MOVE_TO_BASIC_IDS = [8];

export const DISCOUNT_TYPE = {
    DISCOUNT: 1,
    AMOUNT: 2
    
}
export const IS_ACC_TOGGLE ={
  ACTIVE:1,
  INACTIVE:2
}

export const FUEL_TYPE ={
    EV:'Electric',
    HYBRID:'Hybrid'
}

export const VEHICLE_TYPE ={
    EV:3,
    HYBRID:4
}
export const CREATE_PAGE_INDEX={
  CREATE:0,
  ADDONS:1,
  QUOTES:2,
  DOC:3
}
export const PARENT_KEYS=['insurance_exists','vehicle_condition']
export const VEHICLE_CONDITION={'NEW':1,'USED':2}
export const KTP_ID_INPUT_LIMIT = 16;

export const PAYMENT_GENERATE_WEB_SOURCE = 2;
export const HIDE_FOR_COMPANY = ['marital_status','gender','dob','city_birth']
export const POLICY_HOLDER={'PERSONAL':1,'COMPANY':2}
export const FIELD_ORDER = ["province", "city", "district"];
export const SAME_AS_KTP = 2
export const QUOTATION_SHARE_TYPE = {QUOTATION_SHARE:1, QUOTATION_SHARE_NOT:2};
export const ROLE = {
  VP:1,
  SH:2,
  AM:3,
  BM:4,
  AGENT:5
}
export const GENERATE_URL = {
  TRUE:1,
  FALSE:0
}
export const SUBTRACT_YEAR = { ONE: 1, TWO: 2 , THREE: 3, SIX: 6 }; 
export const ALLOW_MONTH = 6
export const LAST_MONTH = 11
export const MAX_DISCOUNT = 25;
export const AGENT_COMMISSION_STATUS = {"pending":0,"approved":1, "rejected":2}
export const LEAD_STATUS:Record<string,any> = {
  "submitted":{
    status_id:1,
    sub_status_id:2
  },
  "policy_issued":{
    status_id:3,
    sub_status_id:4
  },
  "quotation_shared":{
    status_id:1,
    sub_status_id:1
  },
}
export const COMMISSION_DASHBOARD_KEY:Record<string,any>={
  EARNING_SUMMARY:'earning_summary',
  POTENTIAL_PAYMENT:'potential_payment'
}

export const MAX_MOBILE_LENGTH = 12;

export const LEAD_TYPE = {
  AGENT_WEB: 6,
}

export const DOC_IDS = {
  VEHICLE:2,
  EXITING_POLICY:19
}
export const MAX_3_INSURER_ALLOWED = 3
export const LEAD_STATUS_ID = {
  LOST:7
}
export const IS_PAYMENT={
  ALLOWED:1
}
export const IS_HQ=1

export const DOB_MAX_AGE = 17;

export const UPLOAD_TYPE = "insurance_docs"

export const OCR_KTP_ID = 22
export const OCR_NPWP_ID = 4
export const OCR_STNK_ID = 31
export const INSURANCE_TYPE_COMPREHENSIVE = 1;
export const INSURANCE_TYPE_TLO = 2;
export const OCR_EXIST_PARENT_ID = 68;
export const QUOTE_EXPIRED_DAYS = 14
export const QUOTED_EXPIRE_STATUS={
  EXPIRED:1
}